export default __webpack_public_path__ + "static/media/exclamation_mark.900de179.svg";